function initQuestionSliderResults() {
	var $ = jQuery;

	function getAnswers(slider) {
		let questions = $(slider).find('select, input[type="checkbox"]'),
			answers   = {};

		for (let i = 0; i < questions.length; i++) {
			let question = $(questions[i]);

			if (question.is('select')) {
				answers[question.attr('name')] = { value: question.val(), matchLabel: question.data('match-label'), matchValue: question.find('option:selected').text() };
			} else {
				answers[question.attr('value')] = { value: question.is(':checked') ? 'Y' : 'N', matchLabel: question.closest('fieldset').data('match-label'), matchValue: question.text() };
			}
		}

		return answers;
	}

	function getResults(answers, potentialResults) {
		let rankedResults = [],
			results       = [],
			answer_keys   = Object.keys(answers),
			questions     = [];

		//ignore 'results' key && questions that were answered with 'no_preference'
		for (let i = 0; i < answer_keys.length; i++) {
			if (answer_keys[i] !== 'results' && answers[answer_keys[i]] !== 'no_preference') {
				questions.push(answer_keys[i]);
			}
		}

		//short circuit: if all questions were answered with 'no_preference', just return no results
		//(that would happen anyway, but let's skip all this needless work)
		if (questions.length < 1) {
			return results;
		}

		//set up ranked results array
		for (let i = 0; i <= questions.length; i++) {
			rankedResults[i] = [];
		}

		//compute ranking for each potential result (number of matched answers)
		for (let i = 0; i < potentialResults.length; i++) {
			let potentialResult = potentialResults[i],
				matchCount      = 0;

			for (let j = 0; j < questions.length; j++) {
				let question = questions[j];

				if (Array.isArray(potentialResult[question]) && potentialResult[question].includes(answers[question].value)) {
					matchCount++;
				} else if (potentialResult[question] == answers[question].value) {
					matchCount++;
				}
			}
			
			rankedResults[matchCount].push(potentialResult);
		}

		//sort results with the same matchCount alphabetically
		for (let i = 0; i < rankedResults.length; i++) {
			if (rankedResults[i].length > 0 && !rankedResults[i][0].hasOwnProperty('results')) {
				rankedResults[i].sort(function (a, b) {
					return a.title.toLowerCase().localeCompare(b.title.toLowerCase());
				});
			}
		}

		//flatten the array
		//output all results of a given rank, adding new ranks so long as there are fewer than 3 results
		let rank = rankedResults.length; //0, 1, 2, 3 -> length == 4
		while (results.length < 3 && rank > 1) {
			rank--; //first run, decrement 4 to 3, grab all results of rank 3 (3 matched properties)
					//after that, grab rank 2, then 1; never output results of rank 0 (0 matched properties)

			for (let i = 0; i < rankedResults[rank].length; i++) {
				results.push(rankedResults[rank][i]);
			}
		}

		return results;
	}

	$('body').on('uws-question-slider:show-results', function (e) {
		let slider              = $(e.target),
			resultsWrapper      = slider.find('[data-js="results"]'),
			resultsHeader       = slider.find('[data-js="has-results"]'),
			noResultsHeader     = slider.find('[data-js="no-results"]'),
			resultTemplate      = slider.closest('.finder-tool-outer').find('[data-js="result-template"]').html(),
			resultMatchTemplate = slider.closest('.finder-tool-outer').find('[data-js="result-answer-template"]').html(),
			includeMatched      = slider.closest('.finder-tool-outer').data('include-matched-values'),
			potentialResults    = resultsWrapper.data('results-data'),
			answers             = getAnswers(slider),
			answerKeys,
			results             = getResults(answers, potentialResults),
			exactMatch          = resultsWrapper.data('exact-match'),
			resultType          = resultsWrapper.data('type');

		if (exactMatch) {
			results = results.slice(0, 1);
		}

		if (resultType == 'path') {
			let tmpResults = [];
			for (let i = 0; i < results.length; i++) {
				for (let j = 0; j < results[i]['results'].length; j++) {
					tmpResults.push(results[i]['results'][j]);
				}
			}

			results = tmpResults;
		}

		if (results.length > 0) {

			noResultsHeader.hide();
			resultsHeader.show();

			for (let i = 0; i < results.length; i++) {
				let result    = results[i],
					newResult = $(resultTemplate);

				newResult.find('[href]').attr('href', result.permalink);
				newResult.find('.bg-img').css('background-image', 'url(\'' + result.thumbnail + '\')');
				newResult.find('.copy p').first().text(result.title);
				if (result.description) {
					$(newResult.find('.copy p').get(1)).text(result.description).show();
				}

				if (includeMatched) {
					answerKeys = Object.keys(answers);

					for (let j = 0; j < answerKeys.length; j++) {
						let newMatch = $(resultMatchTemplate),
							matched  = false;

						newMatch.find('.label').text(answers[answerKeys[j]].matchLabel + ':');
						newMatch.find('.answer').text(result.labels[answerKeys[j]]);

						if (Array.isArray(result[answerKeys[j]]) && result[answerKeys[j]].includes(answers[answerKeys[j]].value)) {
							matched = true;
						} else if (result[answerKeys[j]] == answers[answerKeys[j]].value) {
							matched = true;
						}

						if (matched) {
							newMatch.find('.value').addClass('matched');
						}

						newResult.find('.values').append(newMatch);
					}

					newResult.find('.values').show();
				}

				resultsWrapper.append(newResult);
			}
		} else {
			resultsHeader.hide();
			noResultsHeader.show();
		}

		resultsWrapper.show();
	});

	$('body').on('uws-question-slider:hide-results', function (e) {
		let slider = $(e.target),
			resultsWrapper = slider.find('[data-js="results"]');

		resultsWrapper.children().remove();
		resultsWrapper.hide();
	});
}

export { initQuestionSliderResults };